//
// Generated class EventPhaseLine
//

/// <reference path="EventPhaseLine_ManagedObject.ts" />

class EventPhaseLine extends EventPhaseLine_ManagedObject
{

}
